<style></style>

<template>
    <div class="dropdown" :class="styleClasses">
        <div class="trigger" :class="{collapsed: !visible}" data-toggle="collapse" :data-target="'#'+id">
            <slot name="trigger"></slot>
        </div>        
        <slot name="between"></slot>
        <div class="collapse collapsed-content" :class="{show: visible}" :id="id" v-bind:accordion="accordion" role="tabpanel">
            <slot name="collapsed-content"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            accordion: {
                type: String,
                default: null
            },
            styleClasses: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        components: {},
        data() {
            return {
                id: 'dropdown-'+Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
            }
        },
    
}
</script>